<template>
  <div class="customerlistinfo" style="position: relative">
    <div class="customListInfoHead">
      <div class="clue-operation">
        <div class="customerListInput">
          <el-input v-model="keyword" placeholder="搜索姓名,手机号,公司"
                    @keyup.enter.native="getClientClueList('search')"
                    @input="getClientListNone()"
          >
            <i
                    class="el-icon-search"
                    slot="suffix"
                    style="width: 30px;height: 40px;cursor: pointer"
                    @click="getClientClueList('search')"
                    >
            </i>
          </el-input>
        </div>
        <!-- <div class="customerListShare" data-clipboard-target>
            <span  @click="shareClick"
                v-clipboard:copy="copyUrl"
                v-clipboard:success="onCopy">
                <i class="arsenal_icon arsenalfenxiang"></i>
                <span style="font-size: 14px">分享</span>
            </span>

        </div> -->
        <!-- <div class="advancedSearch">
                <img src="../../../assets/images/header/u210.png" class="searchImg" >
                <span style="font-size: 14px">高级检索</span>
            </div>
            <div class="batchProcess">
                <img src="../../../assets/images/header/u207.png" class="bacthImg">
                <span style="font-size: 14px">批量处理</span>

            </div> -->


        <!-- <div class="customerListRefresh" @click="refreshClick">
            <i class="el-icon-refresh-right" style="font-size: 20px" >
            </i>
            <span style="font-size: 13px">刷新</span>
        </div>-->
        <div class="batchProcess" @click="openBatch">
          <img src="../../../assets/images/header/u207.png" style="width: 24px;">
          <span style="font-size: 14px">批量导入</span>

        </div>
      </div>
      <div class="customerBtn">
        <div class="switch-dimension">
          <el-switch
              v-model="dimension"
              active-text="客户维度"
              inactive-text="公司维度"
              @change="changeDimension"
          >
          </el-switch>
        </div>

        <el-button type="primary" size="normal" @click="openAddClicnt" class="addCustomerBtn" style="font-size: 14px">
          新增线索
        </el-button>
      </div>

    </div>
    <div class="customerlistinfoContain">
      <customer-info-item
          :clientClue="clientClueList"
          @editCustomClue="editCustomClue"
          ref="customerItem"
          @clueCompanyAdd="getClientCompany"
          :dimension="dimension"
          :companyClueList="companyClueList"
      />

      <div style="position: absolute;left:24px;bottom: 0;line-height:70px" v-if="clientListNum.length > 0">
        <span style="font-size: 13px">共选中<span style="padding: 0 5px">{{ clientListNum.length }}</span>个客户</span>
      </div>
      <div style="position: absolute;bottom: 0px;right: 56px;">
        <el-pagination
            :page-size="customerCluePageSize"
            :current-page.sync="customerCluePage"
            @current-change="handleCurrentChange"
            :total="clientClueTotal"
            background
            :page-sizes="[10, 20, 30, 40]"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            style="text-align: right"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="新增公司"
               :visible.sync="companyDialogFormVisible"
               custom-class="customerListDialog"
               style="text-align: left"
               :close-on-click-modal="false"
               append-to-body
    >
      <add-company ref="addCompany"></add-company>
      <div slot="footer" class="dialog-footer">
        <el-button @click="companyDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClientCompany">保存</el-button>
        <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增客户线索" :visible.sync="dialogFormVisible" width="30%" :close-on-click-modal="false">
      <div class="leads-add-box">
        <el-form v-model="leadsForm">
          <el-form-item label="姓名" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.name" placeholder="请输入客户名称" clearable></el-input>
          </el-form-item>
          <!--                    <el-form-item label="昵称" :label-width="formLabelWidth">
                                  <el-input v-model="leadsForm.nickName" placeholder="请输入客户昵称" clearable></el-input>
                              </el-form-item>-->
          <el-form-item label="性别" :label-width="formLabelWidth">
            <el-radio-group v-model="leadsForm.gender" size="medium">
              <el-radio-button label="男"></el-radio-button>
              <el-radio-button label="女"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生日" :label-width="formLabelWidth">
            <el-date-picker
                v-model="leadsForm.birthDay"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth">
            <el-input
                v-model="leadsForm.mobile"
                placeholder="请输入客户联系方式"
                clearable
                @blur="phoneBlurClick(leadsForm.mobile)"
            ></el-input>
          </el-form-item>
          <el-form-item label="跟进人" :label-width="formLabelWidth">
            <el-select
                v-model="leadsForm.followerId"
                placeholder="请选择跟进人"
                style="width: 100%"
            >
              <el-option
                  v-for="follow in followerList"
                  :key="follow.userid"
                  :label="follow.name"
                  :value="follow.userid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进状态" :label-width="formLabelWidth">
            <el-select
                v-model="leadsForm.statusId"
                placeholder="请选择跟进状态"
                style="width: 100%"
            >
              <el-option
                  v-for="status in statusList"
                  :key="status.id"
                  :label="status.name"
                  :value="status.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="微信号" :label-width="formLabelWidth">
            <el-input
                v-model="leadsForm.weChatNo"
                placeholder="请输入客户微信号"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input
                v-model="leadsForm.mail"
                placeholder="请输入客户邮箱"
                clearable
                @blur="emaiBblurClick(leadsForm.mail)"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司" :label-width="formLabelWidth">
            <div class="selectAndBtn">
              <el-select
                  v-model="leadsForm.companyId"
                  placeholder="请选择公司"
                  style=";position: relative"
              >
                <el-input
                    placeholder="可搜索"
                    v-model="clueCompanyValue"
                    clearable
                    style="position: absolute;top: 0px;z-index: 9;"
                    size="medium"
                    @input="customerClueCompanySelect"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div
                    style="margin-top: 36px"
                    v-if="customerClue.companyList.length > 0"
                >
                  <el-option
                      v-for="item in customerClue.companyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </div>
                <div
                    v-else
                    style="margin-top: 36px"
                >
                  <el-option style="display: flex;justify-content: center;align-items: center">
                    暂无数据
                  </el-option>
                </div>
              </el-select>

              <el-link type="primary" style="margin-left:20px;width: 60px;flex: none" @click="clueAddCompany">新增公司
              </el-link>
            </div>

          </el-form-item>
          <el-form-item label="部门" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.department" placeholder="请输入客户所在部门" clearable></el-input>
          </el-form-item>
          <el-form-item label="职位" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.position" placeholder="请输入客户职位" clearable></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.address" placeholder="请输入客户详细地址" clearable></el-input>
          </el-form-item>

          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="leadsForm.description"
                maxlength="200"
                show-word-limit
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClient">保存</el-button>
        <el-button type="primary" @click="addClientContinue">保存并继续添加</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="批量导入"
        :visible.sync="dialogVisibleBatch"
        :close-on-click-modal="false"
        style="text-align: left;"
        width="600px"

    >
      <div class="explain">
        <span>说明：导入Excel表格行数上限为100000行，文件大小上限为5Mb。</span>
      </div>
      <div class="moreInText">
        <div class="moreInTextItem">1.根据模板要求填写模板文件</div>
        <div class="moreInTextItem">2.选择文件，开始导入</div>
      </div>
      <div class="editUpload">
        <el-upload
            class="upload-demo"
            :action="uploadAction"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple
            accept=".xlsx,xls"
            :before-upload="beforeAvatarUpload"
            :on-success="handleSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList">
          <div class="selectFileBtn">选择文件</div>
        </el-upload>
      </div>
      <div class="noTemplate">
        还没有线索模板？点击下载<span style="color: #409eff;font-size: 16px;cursor: pointer">
                <a style="text-decoration: none;color: #409eff" :href="templateUrl" target="_blank">《批量导入客户线索模板》</a>
              </span>
      </div>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisibleBatch = false">取 消</el-button>
                            <el-button type="primary" @click="startUpLoad">开始上传</el-button>
                        </span>
    </el-dialog>
    <!-- 导入如果错误显示错误信息 -->
    <el-dialog
        title="批量导入客户线索错误提示"
        :visible.sync="clueErrordialogTableVisible"
        :close-on-click-modal="false"
        append-to-body
    >
      <el-table
          :data="errorData"
           height="calc(100vh - 400px)"
      >
        <el-table-column
            property="line"
            label="错误行数"
            align="center"
            width="80"
        ></el-table-column>
        <el-table-column property="errorMessage" label="错误原因" min-width="200"></el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>


import CustomerInfoItem from "./CustomerInfoItem";
import AddCompany from "../components/addCompany";

export default {
  name: "CustomerListInfo",
  components: {AddCompany, CustomerInfoItem},
  data() {
    return {
      companyDialogFormVisible: false,
      formLabelWidth: '80px',
      leadsForm: {
        nickName: '',
        gender: '',
        birthDay: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: '',
        followerId: "",
        weChatNo: '',
        statusId:''
      },
      followerList: [],
      customerClue: {
        companyList: [],
        sourceList: [],
      },
      checked: false,
      length: 0,
      pageSize: 20,
      currentPage: 1,
      newClient: {
        list: [],
        total: 0
      },
      keyword: '',
      dialogVisible2: false,
      dialogFormVisible: false,
      clientName: '',
      radio: '1',
      clientGrade: '',
      clientTel: '',
      clientMail: '',
      companyId: '',
      companyName: '',
      fieldList: '',
      companyValue: '',
      inputSelect: '',
      companys: '',
      groupValue: '',
      groupSelect: '',
      groups: '',
      personValue: '',
      personSelect: '',
      persons: '',
      describe: '',
      num: 0,
      allChecked: 0,
      accountGroup: {
        list: []
      },
      accountPerson: {
        list: []
      },
      company: {
        list: []
      },
      addCompanyName: '',
      emailSuffix: '',
      contactPerson: '',
      contactPersonMail: '',
      contactPersonTel: '',
      description: '',
      companyPersonValue: '',
      companyGroupValue: '',
      levelRadio: '1',
      grade: '',
      isCheck: false,
      copyUrl: '',
      AllnewClient: {
        list: []
      },
      clientList: [],
      selectCompanyList: [],
      selectGroupList: [],
      selectPersonList: [],
      CompanyPageSize: 10000,
      copyUrl1: '',
      companyPersonSelect: '',
      companyGroupSelect: '',
      companyAccountGroup: [],
      companySelectGroupList: [],
      CompanyAccountPerson: [],
      companySelectPerson: [],
      addCompanySuccess: false,
      clientListNum: '',
      customerCluePage: 1,
      customerCluePageSize: 10,
      clientClueList: [],
      clientClueTotal: 0,
      clueCompanyValue: '',
      addCompanyInfo: {
        contactPerson: '',
        contactPersonMail: '',
        contactPersonTel: '',
        description: '',
        groupId: '',
        name: '',
        principalId: '',
        grade: 'NORMAL',
        mailSuffix: '',
      },
      statusList: [],
      dialogVisibleBatch: false,
      uploadAction: '/open-api/oss/public?token=8c98087dfd2d48f856d8c95c09115def',
      fileList: [],
      templateUrl: '/scrm-api/custom-clue-batch/template',
      excelName: '',
      excelUrl: '',
      errorData:[],
      clueErrordialogTableVisible:false,
      dimension:true,
      companyClueList:[]

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getClientCompany()
      this.getClientList()
      this.getFollowList()
      this.getStatusList()
    })
  },
  methods: {
    search() {
      let filterId = this.$route.query.id;
      let searchParam = {
        type: 'CLIENT',
        page: this.currentPage,
        size: this.pageSize,
        keyword: this.keyword
      }
      if (filterId) {
        searchParam.filterId = filterId;
      }
      console.log("search param:", searchParam);

      this.$http.get('/api/search', {params: searchParam})
          .then(response => {

            this.newClient.list = response.data.data.content;
            this.newClient.total = response.data.data.totalElements

            this.$emit('search', this.newClient.list, filterId)
            console.debug('FieldApiExample field page:', this.newClient);
          })

    },
    editCustomClue() {
      let data = Object.assign({}, this.customerCluePage, {
        page: this.customerCluePage - 1
      })
      
      let url = '/scrm-api/custom-clue/page?page=' + data.page + '&size=' + this.customerCluePageSize;
      let privilege =  localStorage.getItem('appoint_scrm_all_clue_privilege');
      if(privilege!=null){
          url = url + '&scrmAllCluePrivilege='+privilege;
      }
      let filterId = ''
      if (this.$route.query.id) {
        filterId = this.$route.query.id
      }
      url += '&filterId=' + filterId + '&keyword=' + this.keyword
      this.$http.get(url).then(res => {
        this.clientClueList = res.data.content
        this.clientClueTotal = res.data.totalElements
        this.$nextTick(() => {
          this.$refs.customerItem.clueInfo = this.clientClueList[this.$refs.customerItem.clueIndex]
        })
      })
      this.$emit('editCustomer')
    },
    //获取跟进人
    getFollowList() {
      let url = '/scrm-api/we-work/member/list'
      this.$http.get(url).then(res => {
        this.followerList = res.data
        this.$nextTick(() => {
          if (this.$refs.customerItem) {
            this.$refs.customerItem.followerList = res.data
          }

        })
      })
    },
    //获取状态List
    getStatusList() {
      let url = '/scrm-api/followup-status'
      this.$http.get(url).then(res => {
        this.statusList = res.data
        this.$refs.customerItem.statusList = res.data
      })
    },
    //切换查看维度
    changeDimension(value){
      if (value){
        this.getClientList()
      }
      else {
        this.getClueList()
      }
    },
    getClientClueList(type){
      if (this.dimension){
        this.getClientList(type)
      }
      else {
        this.getClueList(type)
      }
    },
    //获取客户的信息
    getClientList(type) {
      if (type === 'search') {
        this.customerCluePage = 1
      }
      let data = Object.assign({}, this.customerCluePage, {
        page: this.customerCluePage - 1
      })
      let url = '/scrm-api/custom-clue/page?page=' + data.page + '&size=' + this.customerCluePageSize;
      
      let privilege =  localStorage.getItem('appoint_scrm_all_clue_privilege');
      if(privilege!=null){
          url = url + '&scrmAllCluePrivilege='+privilege;
      }
      let filterId = ''
      if (this.$route.query.id) {
        filterId = this.$route.query.id
      }
      url += '&filterId=' + filterId + '&keyword=' + this.keyword
      if (this.$refs.customerItem){
        this.$refs.customerItem.tableDataLoading = true
      }
      this.$http.get(url).then(res => {
        console.log('客户线索获取', res.data)
        this.clientClueList = res.data.content
        this.clientClueTotal = res.data.totalElements
        this.$refs.customerItem.tableDataLoading = false;
        console.log('客户线索获取', this.clientClueList)
      })
    },
    //以公司维度查看线索
    getClueList(type){
      if (type === 'search') {
        this.customerCluePage = 1
      }
      let url = '/scrm-api/custom-clue/page-group-by-company'
      let data = Object.assign({}, this.customerCluePage, {
        page: this.customerCluePage - 1
      })
      url += '?page=' +data.page + '&size=' + this.customerCluePageSize
      let privilege =  localStorage.getItem('appoint_scrm_all_clue_privilege');
      if(privilege!=null){
        url = url + '&scrmAllCluePrivilege='+privilege;
      }
      let filterId = ''
      if (this.$route.query.id) {
        filterId = this.$route.query.id
      }
      url += '&filterId=' + filterId + '&keyword=' + this.keyword
      if (this.$refs.customerItem){
        this.$refs.customerItem.tableDataLoading = true
      }
      this.$http.get(url).then(res=>{
        console.debug('getClueList',res)
        if (res.status===200){
          this.companyClueList = res.data.content
          this.clientClueTotal = res.data.totalElements
          this.$refs.customerItem.tableDataLoading = false
        }
      })
    },
    getClientListNone(){
      if (!this.keyword){
        if (this.dimension){
          this.getClientList('search')
        }
        else {
          this.getClueList('search')
        }
        this.$refs.customerItem.tableDataLoading = false;
        /*this.customerCluePage = 1
        let data = Object.assign({}, this.customerCluePage, {
          page: this.customerCluePage - 1
        })
        let url = '/scrm-api/custom-clue/page?page=' + data.page + '&size=' + this.customerCluePageSize;
        let privilege =  localStorage.getItem('appoint_scrm_all_clue_privilege');
        if(privilege!=null){
            url = url + '&scrmAllCluePrivilege='+privilege;
        }
        let filterId = ''
        if (this.$route.query.id) {
          filterId = this.$route.query.id
        }
        url += '&filterId=' + filterId + '&keyword=' + this.keyword
        this.$http.get(url).then(res => {
          console.log('客户线索获取', res.data)
          this.clientClueList = res.data.content
          this.clientClueTotal = res.data.totalElements
          this.$refs.customerItem.tableDataLoading = false;
          console.log('客户线索获取', this.clientClueList)
        })*/
      }
    },

    openAddClicnt() {
      this.leadsForm = {
        nickName: '',
        gender: '',
        birthday: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: '',
        followerId: "",
        weChatNo: '',
        statusId:''
      }
      if (this.statusList.length > 0) {
        this.leadsForm.statusId = this.statusList[0].id
      }
      this.dialogFormVisible = true

    },
    clientClueAdd(type) {
      if (this.leadsForm.name === '') {
        this.$message({
          message: '请输入客户名称',
          type: 'warning',
          duration: 2000
        })
        return;
      }
      if (!this.emaiBblurClick(this.leadsForm.mail)) {
        return;
      }
      if (!this.phoneBlurClick(this.leadsForm.mobile)) {
        return
      }
      if (!this.leadsForm.mail && (!this.leadsForm.mobile) && (!this.leadsForm.weChatNo)) {
        this.$message({
          message: '手机号,邮箱,微信号最少填写一项',
          type: 'warning',
          duration: 2000
        })
        return;
      }
      let url = '/scrm-api/custom-clue'
      this.$http.post(url, this.leadsForm).then(res => {
        this.$message({
          message: '添加客户线索成功',
          duration: 2000,
          type: 'success'
        })
        if (this.dimension){
          this.getClientList()
        }
        else {
          this.getClueList()
        }
        if (type) {
          this.dialogFormVisible = false
        } else {
          this.dialogFormVisible = true
        }
        this.leadsForm = {
          nickName: '',
          gender: '',
          birthday: '',
          address: '',
          companyId: "",
          department: "",
          description: "",
          mail: "",
          name: "",
          position: "",
          source: "ADD_MANULLY",
          mobile: '',
          followerId: "",
          weChatNo: '',
          statusId:''
        }
      this.$emit('editCustomer')
      }).catch(res => {
        this.$message({
          message: '该手机号已添加过客户线索，请不要重复添加',
          type: 'warning',
          duration: 3000
        })
      })
    },
    //新增客户
    addClient() {
      this.clientClueAdd(true)
    },
    addClientContinue() {
      this.clientClueAdd(false)
    },
    //获取负责组下拉列表值
    getAccountGroup() {
      this.$http.get('/api/account/group').then(res => {
        this.accountGroup.list = res.data.data
        this.companySelectGroupList = res.data.data
      })
    },
    getCompanyAccountPerson() {
      if (this.addCompanyInfo.groupId !== '') {
        this.$http.get('/api/account/principal?groupId=' + this.addCompanyInfo.groupId).then(res => {
          this.accountPerson.list = res.data.data
          this.companySelectPerson = res.data.data
        })
      } else {
        this.$http.get('/api/account/principal?groupId=%20').then(res => {
          this.accountPerson.list = res.data.data
          this.companySelectPerson = res.data.data
        })
      }
    },
    //获取公司的下拉列表值
    getClientCompany() {
      console.log(this.addCompanySuccess)
      this.$http.get('/api/client-company/page?num=' + this.CompanyPageSize + '&page=' + this.currentPage).then(response => {
        console.log('response', response)
        this.selectCompanyList = response.data.data.content
        this.customerClue.companyList = response.data.data.content

        if (this.addCompanySuccess === true) {
          let length = this.customerClue.companyList.length
          this.leadsForm.companyId = this.customerClue.companyList[length - 1].id
        }


        console.debug('FieldApiExample field page:', this.clientCompany);
      })
    },

    deleteClientInfo() {
      this.$emit('deleteClientInfo', this.pageSize, this.currentPage)

    },
    modifyClientClick() {


    },
    handleSizeChange(value) {
      this.customerCluePageSize = value;
      if (this.dimension){
        this.getClientList()
      }
      else {
        this.getClueList()
      }
    },
    handleCurrentChange(value) {
      this.customerCluePage = value
      if (this.dimension){
        this.getClientList()
      }
      else {
        this.getClueList()
      }

    },
    refreshClick() {
      this.$router.go(0)
    },
    change(value) {
      if (value === true)
        this.newClient.list.checked = true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = []
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.error('只能上传一个模板')
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    allCheck(num) {
      console.log(num)
    },

    clueAddCompany() {
      this.$nextTick(() => {
        this.$refs.addCompany.addCompanyInfo = {
          contactPerson: '',
          contactPersonMail: '',
          contactPersonTel: '',
          description: '',
          groupId: '',
          name: '',
          principalId: '',
          grade: 'NORMAL',
          mailSuffix: '',
        }
      })
      this.companyDialogFormVisible = true
    },
    clueCompanyAdd() {
      this.$nextTick(() => {
        let addCompany = this.$refs.addCompany.addCompanyInfo
        if (addCompany.name === '') {
          this.$message('请输入公司名称')
          return;
        }
        if (!this.$refs.addCompany.phoneClick(addCompany.contactPersonTel)) {
          return
        }
        if (!this.$refs.addCompany.emailClick(addCompany.contactPersonMail)) {
          return;
        }

        this.$http.post('/api/client-company', addCompany).then(res => {
          if (res.data.code === '0') {
            this.$message.success('添加公司成功')
            this.addCompanySuccess = true
          } else {
            this.$message.error(res.message)
          }
          this.getClientCompany()
        });
      })

    },
    //新增公司
    addClientCompany() {
      this.clueCompanyAdd()
      this.companyDialogFormVisible = false

    },
    //保存并且继续新增
    addCompanyContinue() {
      this.clueCompanyAdd()
      this.$nextTick(() => {
        this.$refs.addCompany.addCompanyInfo = {
          contactPerson: '',
          contactPersonMail: '',
          contactPersonTel: '',
          description: '',
          groupId: '',
          name: '',
          principalId: '',
          grade: 'NORMAL',
          mailSuffix: '',
        }
      })
    },

    //打开批量导入
    openBatch() {
      this.dialogVisibleBatch = true
      this.fileList = []
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传的文件大小不能超过5M')
      }
      return isLt5M
    },
    handleSuccess(res, file) {
      console.log(res)
      this.excelUrl = res
      console.log(file)
      this.excelName = file.name
    },
    startUpLoad() {
      if (this.excelUrl !== '') {
        let fileInfo = {
          url: this.excelUrl
        }
        let reqUrl = '/scrm-api/custom-clue-batch'
        this.$http.post(reqUrl, fileInfo).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.$message({
              message: '导入成功',
              type: 'success',
              duration: 2000
            })
            if (this.dimension){
              this.getClientList()
            }
            else {
              this.getClueList()
            }
            this.getBatchError(res.data)
          }
        })
        this.dialogVisibleBatch = false
      } else {
        this.$message({
          message: '请选择上传文件',
          type: 'error',
          duration: 2000
        })
        return
      }

    },
    getBatchError(id){
      let url='/scrm-api/custom-clue-batch/record/'+id
      this.$http.get(url).then(res=>{
        if (res.status===200){
          console.log(res)
          let originClue = res.data.originClues
          this.errorData = []
          for (let i=0;i<originClue.length;i++){
            console.log(originClue[i])
            if (originClue[i].hasError){
              this.errorData.push({line:originClue[i].line,errorMessage:originClue[i].errorMessage})
            }
          }
          if (this.errorData.length > 0){
            this.clueErrordialogTableVisible = true
          }

        }
      })
    },
    emaiBblurClick(mail) {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (mail !== '') {
        if (!reg.test(mail)) {
          this.$message('请输入有效的邮箱')
          return false
        } else {
          return true
        }

      } else
        return true

    },
    phoneBlurClick(mobile) {
      const phone = /^[1][3,4,5,7,8][0-9]{9}$/
      var reg02 = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
      if (mobile) {
        if (!phone.test(mobile) && !reg02.test(mobile)) {
          this.$message('请输入有效的电话号码')
          return false
        } else {
          return true
        }
      } else
        return true

    },
    handleSelectionChange(value) {
      this.clientListNum = value
      this.clientList = value
    },
    shareClick() {
      if (this.clientList.length === 0) {
        this.$message({
          message: '请选择要分享的客户',
          type: "error",
          duration: 800
        })
      } else {
        this.copyUrl = ''
        this.copyUrl1 = ''
        for (let i = 0; i < this.clientList.length; i++) {
          if (this.clientList[i] !== undefined) {
            let grade = ''
            if (this.clientList[i].grade === 'VIP')
              grade = 'VIP'
            if (this.clientList[i].grade === 'NORMAL')
              grade = '普通'

            console.log(grade)
            if (this.clientList[i].companyId !== '' && this.clientList[i].groupId !== '' && this.clientList[i].principalId !== '' && this.clientList[i].tel !== '' && this.clientList[i].mail !== '') {
              this.copyUrl1 += '姓名:' + " \xa0" + this.clientList[i].name + '\n' + '公司:' + " \xa0" + this.clientList[i].company.name + "\n" + '电话:' + " \xa0" + this.clientList[i].tel + "\n" + '邮箱:' + " \xa0" + this.clientList[i].mail + '\n' + '等级:' + " \xa0" + grade + '\n' + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '负责人:' + " \xa0 " + this.clientList[i].principal.name + '\n' + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].groupId !== '' && this.clientList[i].tel !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + "\n" + '电话:' + " \xa0" + this.clientList[i].tel + "\n" + '邮箱:' + " \xa0" + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + "\n" + '负责组' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].principalId !== '' && this.clientList[i].tel !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + "\n" + '电话:' + " \xa0 " + this.clientList[i].tel + '\n' + '等级:' + " \xa0 " + grade + '\n' + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '负责人:' + " \xa0 " + this.clientList[i].principal.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0" + this.clientList[i].name + '\n' + '公司:' + " \xa0" + this.clientList[i].company.name + "\n" + '邮箱:' + " \xa0" + this.clientList[i].mail + '\n' + '等级:' + " \xa0" + grade + '\n' + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '负责人:' + " \xa0 " + this.clientList[i].principal.name + '\n' + '------------------------------------' + '\n'

            } else if (this.clientList[i].tel !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0" + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + '\n' + '邮箱:' + " \xa0" + this.clientList[i].mail + '\n' + '等级:' + " \xa0" + grade + '\n' + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '负责人:' + " \xa0 " + this.clientList[i].principal.name + '\n' + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].tel !== '' && this.clientList[i].mail !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + "\n" + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + "\n " + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].tel !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].companyId !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + "\n" + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].companyId !== '' && this.clientList[i].tel !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + "\n" + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].mail !== '' && this.clientList[i].principalId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + '\n' + '负责人:' + " \xa0 " + this.clientList[i].principal.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].principalId !== '' && this.clientList[i].tel !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + this.clientList[i].tel + "\n" + "等级:" + grade + "\n" + '负责组:' + " \xa0 " + this.clientList[i].group.name + '负责人:' + this.clientList[i].principal.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].tel !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + "等级:" + " \xa0 " + grade + "\n" + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].companyId !== '' && this.clientList[i].mail !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '邮箱:' + " \xa0 " + this.clientList[i].mail + "\n" + "等级:" + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].principalId !== '' && this.clientList[i].companyId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司名称:' + " \xa0 " + this.clientList[i].company.name + "\n" + "等级:" + grade + "\n" + '负责组:' + " \xa0 " + this.clientList[i].group.name + '\n' + '负责人:' + this.clientList[i].principal.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].tel !== '' && this.clientList[i].mail !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].tel !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + "\n" + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].mail !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + '负责组:' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].tel !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '电话:' + " \xa0 " + this.clientList[i].tel + '\n' + '等级:' + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].mail !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '邮箱:' + " \xa0 " + this.clientList[i].mail + '\n' + '等级:' + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'

            } else if (this.clientList[i].groupId !== '' && this.clientList[i].principalId === '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '等级:' + " \xa0 " + grade + '\n' + '负责组' + " \xa0 " + this.clientList[i].group.name + "\n" + '------------------------------------' + '\n'
            } else if (this.clientList[i].principalId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '等级:' + " \xa0 " + grade + '\n' + '负责组:' + " \xa0 " + this.clientList[i].group.name + '\n' + '负责人:' + " \xa0 " + this.clientList[i].principal.name + "\n" + '------------------------------------' + '\n'
            } else if (this.clientList[i].companyId !== '') {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + '\n' + '公司:' + " \xa0 " + this.clientList[i].company.name + '\n' + '等级:' + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'
            } else {
              this.copyUrl1 += '姓名:' + " \xa0 " + this.clientList[i].name + "\n" + '等级:' + " \xa0 " + grade + "\n" + '------------------------------------' + '\n'

            }
          }

        }
        this.copyUrl = '向您分享了客户' + '\n' + '\n' + this.copyUrl1
      }

    },
    onCopy() {
      this.$message({
        message: '分享成功',
        type: "success",
        duration: 800
      })
    },
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },
    //下拉加载公司
    loadMore() {
      this.CompanyPageSize += 10
      this.getClientCompany()
    },

    //获取搜索公司的下拉值
    customerClueCompanySelect() {
      if (this.clueCompanyValue !== '') {
        let selectCompany = []
        this.selectCompanyList.forEach((item) => {
          if (!!~item.name.indexOf(this.clueCompanyValue) || !!~item.name.toUpperCase().indexOf(this.clueCompanyValue.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.customerClue.companyList = selectCompany

      } else {
        this.customerClue.companyList = this.selectCompanyList
      }

    },

    changeSelectCompanyGroup(value) {
      if (value !== '') {
        let selectCompanyGroup = []
        this.accountGroup.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompanyGroup.push(item)
          }
        })
        this.companySelectGroupList = selectCompanyGroup

      } else {
        this.companySelectGroupList = this.accountGroup.list
      }
    },
    changeSelectCompanyPerson(value) {
      if (value !== '') {
        let selectCompanyPerson = []
        this.accountPerson.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompanyPerson.push(item)
          }
        })
        this.companySelectPerson = selectCompanyPerson

      } else {
        this.companySelectPerson = this.accountPerson.list
      }

    },

  },
  beforeRouteUpdate(to, from, next) {
    next()
    if (this.dimension){
      this.getClientList()
    }
    else {
      this.getClueList()
    }
  },


}
</script>

<style scoped lang="less">
@import "../../../assets/less/customlist/customerlistinfo/customerlistinfo";

.clientName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.isNullOption {
  top: 45px;
}

.clue-operation {
  .batchProcess {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer
  }
}

.explain {
  height: 60px;
  line-height: 1.5;
  margin: 0 0 14px 0;

  span {
    font-size: 22px;
    font-weight: 500;
  }
}

.moreInText {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 14px;

  .moreInTextItem {
    line-height: 2;
  }
}

.noTemplate {
  margin-top: 14px;
}
</style>